import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Companion_instanceovl8he3jiijf as Companion_instance } from './AbstractList.mjs';
import { AbstractMutableList192xfq8ycgofs as AbstractMutableList } from './AbstractMutableListJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import {
  copyToArray2j022khrow2yi as copyToArray,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from './collectionJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from './CollectionsKt.mjs';
import { indexOf3ic8eacwbbrog as indexOf } from './_Arrays.mjs';
import { arrayToString1r7op7afgkivw as arrayToString } from './collectionsHacks.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from './Collections.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = ArrayList().u(0);
        this_0.t_1 = true;
        tmp.b8_1 = this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
function increaseLength($this, amount) {
  var previous = $this.p1();
  // Inline function 'kotlin.js.asDynamic' call
  $this.s_1.length = $this.p1() + amount | 0;
  return previous;
}
function rangeCheck($this, index) {
  // Inline function 'kotlin.apply' call
  Companion_instance.f7(index, $this.p1());
  return index;
}
function insertionRangeCheck($this, index) {
  // Inline function 'kotlin.apply' call
  Companion_instance.u6(index, $this.p1());
  return index;
}
var ArrayListClass;
function ArrayList() {
  if (ArrayListClass === VOID) {
    class $ extends AbstractMutableList() {
      static s5(array) {
        Companion_getInstance();
        var $this = this.e7();
        $this.s_1 = array;
        $this.t_1 = false;
        return $this;
      }
      static w() {
        Companion_getInstance();
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$0 = [];
        return this.s5(tmp$ret$0);
      }
      static u(initialCapacity) {
        Companion_getInstance();
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$0 = [];
        var $this = this.s5(tmp$ret$0);
        // Inline function 'kotlin.require' call
        if (!(initialCapacity >= 0)) {
          var message = 'Negative initial capacity: ' + initialCapacity;
          throw IllegalArgumentException().a1(toString(message));
        }
        return $this;
      }
      static b1(elements) {
        Companion_getInstance();
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$0 = copyToArray(elements);
        return this.s5(tmp$ret$0);
      }
      c8() {
        this.k6();
        this.t_1 = true;
        return this.p1() > 0 ? this : Companion_getInstance().b8_1;
      }
      d8(minCapacity) {
      }
      p1() {
        return this.s_1.length;
      }
      q1(index) {
        var tmp = this.s_1[rangeCheck(this, index)];
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      }
      b2(index, element) {
        this.k6();
        rangeCheck(this, index);
        // Inline function 'kotlin.apply' call
        var this_0 = this.s_1[index];
        this.s_1[index] = element;
        var tmp = this_0;
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      }
      v(element) {
        this.k6();
        // Inline function 'kotlin.js.asDynamic' call
        this.s_1.push(element);
        this.p6_1 = this.p6_1 + 1 | 0;
        return true;
      }
      y3(index, element) {
        this.k6();
        // Inline function 'kotlin.js.asDynamic' call
        this.s_1.splice(insertionRangeCheck(this, index), 0, element);
        this.p6_1 = this.p6_1 + 1 | 0;
      }
      r1(elements) {
        this.k6();
        if (elements.i1())
          return false;
        var offset = increaseLength(this, elements.p1());
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index = 0;
        var _iterator__ex2g4s = elements.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          var index_0 = checkIndexOverflow(_unary__edvuaz);
          this.s_1[offset + index_0 | 0] = item;
        }
        this.p6_1 = this.p6_1 + 1 | 0;
        return true;
      }
      z3(index) {
        this.k6();
        rangeCheck(this, index);
        this.p6_1 = this.p6_1 + 1 | 0;
        var tmp;
        if (index === get_lastIndex(this)) {
          // Inline function 'kotlin.js.asDynamic' call
          tmp = this.s_1.pop();
        } else {
          // Inline function 'kotlin.js.asDynamic' call
          tmp = this.s_1.splice(index, 1)[0];
        }
        return tmp;
      }
      w3(element) {
        this.k6();
        var inductionVariable = 0;
        var last = this.s_1.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (equals(this.s_1[index], element)) {
              // Inline function 'kotlin.js.asDynamic' call
              this.s_1.splice(index, 1);
              this.p6_1 = this.p6_1 + 1 | 0;
              return true;
            }
          }
           while (inductionVariable <= last);
        return false;
      }
      g7(fromIndex, toIndex) {
        this.k6();
        this.p6_1 = this.p6_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        this.s_1.splice(fromIndex, toIndex - fromIndex | 0);
      }
      v3() {
        this.k6();
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.s_1 = [];
        this.p6_1 = this.p6_1 + 1 | 0;
      }
      s1(element) {
        return indexOf(this.s_1, element);
      }
      toString() {
        return arrayToString(this.s_1);
      }
      e8() {
        return [].slice.call(this.s_1);
      }
      toArray() {
        return this.e8();
      }
      k6() {
        if (this.t_1)
          throw UnsupportedOperationException().f8();
      }
    }
    initMetadataForClass($, 'ArrayList', $.w, VOID, [AbstractMutableList(), KtMutableList(), RandomAccess()]);
    ArrayListClass = $;
  }
  return ArrayListClass;
}
//region block: exports
export {
  ArrayList as ArrayList3it5z8td81qkl,
};
//endregion

//# sourceMappingURL=ArrayListJs.mjs.map
